module.exports = __webpack_public_path__ + "static/the-boys-in-the-boat-8164bed4adef70c77755db59ff8df6d1.jpg";